import { render, staticRenderFns } from "./UserNotificationsEmptyState.vue?vue&type=template&id=20c652a3&scoped=true&"
import script from "./UserNotificationsEmptyState.vue?vue&type=script&lang=js&"
export * from "./UserNotificationsEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./UserNotificationsEmptyState.vue?vue&type=style&index=0&id=20c652a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c652a3",
  null
  
)

export default component.exports